import styled from '@emotion/styled';
import { FC } from 'react';
import RecentProductCarousel from './RecentProductCarousel';
import Link from 'components/base/Link';
import Text from 'components/base/Text';
import { useRecentProductList } from 'queries/like/useRecentProductList';
import { useTracker } from 'util/Tracker';

interface Props {
  navigation: string;
}
const RecentProducts: FC<Props> = ({ navigation }) => {
  const tracker = useTracker();
  const { recent_product_list, is_recent_product_loading } = useRecentProductList();
  const is_empty = !is_recent_product_loading && recent_product_list.length === 0;

  const handleAllViewClick = () => {
    tracker.addLog({
      category: 'click',
      navigation,
      object_section: 'recently_view_carousel',
      object_type: 'button',
      object_id: 'view_all',
    });
  };

  if (is_empty) {
    return null;
  }
  return (
    <SC.Container>
      <SC.Title>
        <Text variant='title4_bold' color='gray_primary'>
          최근 본 상품
        </Text>
        <Link href='/recent-products' onClick={handleAllViewClick}>
          <Text variant='body4_medium' color='gray_secondary'>
            모두 보기
          </Text>
        </Link>
      </SC.Title>
      <RecentProductCarousel
        recent_product_list={recent_product_list}
        navigation={navigation}
        is_loading={is_recent_product_loading}
      />
    </SC.Container>
  );
};

export default RecentProducts;

const SC = {
  Container: styled.article``,
  Title: styled.div`
    height: 52px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
  `,
};
